import React from 'react';
import PropTypes from 'prop-types';

import { useTranslation } from 'react-i18next';
import MuiTableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Tooltip from '@material-ui/core/Tooltip';
import { Typography } from '@material-ui/core';

const TableHead = ({ order, orderBy, columns, onRequestSort, withActionCell }) => {
	const { t } = useTranslation();
	const createSortHandler = property => event => {
		onRequestSort(event, property);
	};

	return (
		<MuiTableHead>
			<TableRow>
				{columns.map((col, index) =>
					col.sortable ? (
						<TableCell key={index} align="left" sortDirection={orderBy === col.key ? order : false}>
							<Tooltip
								title={`${t('components.select.table.sortBy')} ${col.label}`}
								placement={col.numeric ? 'bottom-end' : 'bottom-start'}
								enterDelay={300}>
								<TableSortLabel active={orderBy === col.key} direction={order} onClick={createSortHandler(col.key)}>
									<Typography>{col.label + ' ' + col.unit}</Typography>
								</TableSortLabel>
							</Tooltip>
						</TableCell>
					) : (
						<TableCell key={index} align="left">
							<Typography>{col.label + col.unit}</Typography>
						</TableCell>
					)
				)}

				{withActionCell && <TableCell align={'right'} />}
			</TableRow>
		</MuiTableHead>
	);
};

TableHead.propTypes = {
	order: PropTypes.string.isRequired,
	orderBy: PropTypes.string.isRequired,
	columns: PropTypes.arrayOf(PropTypes.object).isRequired,
	onRequestSort: PropTypes.func.isRequired,
	withActionCell: PropTypes.bool
};

export default TableHead;
